module.exports = __webpack_public_path__ + "static/bluevelourwhale-a200dfaa0d022e91aaa7a9e8ae413684.jpeg";